import React from 'react';

const PrivacyPolicy = () => (
  <div className="min-h-screen bg-gradient-to-b from-white to-slate-50">
    <main className="pt-20 px-4 sm:px-6 lg:px-8 pb-24">
      <div className="max-w-4xl mx-auto space-y-8">
        <div className="space-y-2">
          <h1 className="text-5xl font-bold text-slate-900">Privacy Policy</h1>
          <p className="text-slate-600">Last Updated: January 2026</p>
        </div>

        <p className="text-lg text-slate-600 leading-relaxed border-l-4 border-blue-500 pl-4">
          At Mustan-Dev, we respect your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website or engage with our services.
        </p>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-slate-900">1. Information We Collect</h2>
          <div className="space-y-3 text-slate-600">
            <p><strong>Voluntarily Provided Information:</strong> When you use our contact form, email us directly, or inquire about services, you may provide your name, email address, company, project details, and any other information you choose to share.</p>
            <p><strong>Automatically Collected Data:</strong> Our website uses analytics tools (Google Analytics) to gather non-personally identifiable data such as page visits, session duration, browser type, and referral sources. This helps us understand user behavior and optimize the site experience.</p>
            <p><strong>Cookies:</strong> We use minimal cookies to maintain session information and remember your preferences. You can disable cookies in your browser settings if you prefer.</p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-slate-900">2. How We Use Your Information</h2>
          <ul className="space-y-2 text-slate-600 list-disc list-inside">
            <li>To respond to inquiries and provide requested services</li>
            <li>To maintain a secure project management inbox for ongoing communication</li>
            <li>To improve website performance and user experience</li>
            <li>To send occasional project updates or service notifications (only with your consent)</li>
            <li>To comply with legal obligations</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-slate-900">3. Data Security</h2>
          <p className="text-slate-600">
            Your data is protected by industry-standard security practices. The website is hosted on Firebase with SSL/TLS encryption enabled, ensuring all transmissions are secure. We do not store sensitive data (like credit card information) directly; payment processing is handled by verified third-party services.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-slate-900">4. Third-Party Services</h2>
          <div className="space-y-3 text-slate-600">
            <p><strong>Firebase Hosting:</strong> Website hosting and analytics</p>
            <p><strong>Google Analytics:</strong> Traffic and behavior analysis (anonymized)</p>
            <p><strong>GitHub Integration:</strong> Portfolio and project links (public data only)</p>
            <p>We do not sell, trade, or share your personal information with third parties without explicit consent, except where required by law.</p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-slate-900">5. Your Rights</h2>
          <p className="text-slate-600">
            You have the right to request, access, modify, or delete your personal information at any time. To exercise these rights, please contact us at <a href="mailto:info@mustan.dev" className="text-blue-600 hover:underline">info@mustan.dev</a>.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-slate-900">6. GDPR & Data Protection</h2>
          <p className="text-slate-600">
            We comply with GDPR and applicable data protection regulations. If you are located in the EU, you have additional rights regarding your personal data. We process your data lawfully and only for specified purposes.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-slate-900">7. Changes to This Policy</h2>
          <p className="text-slate-600">
            This Privacy Policy may be updated periodically to reflect changes in our practices or legal requirements. We will notify users of significant changes via email or a prominent notice on the website.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-slate-900">8. Contact Us</h2>
          <p className="text-slate-600">
            If you have questions about this Privacy Policy or our data practices, please reach out:
          </p>
          <div className="bg-slate-100 p-4 rounded-lg text-slate-700">
            <p><strong>Email:</strong> <a href="mailto:info@mustan.dev" className="text-blue-600 hover:underline">info@mustan.dev</a></p>
            <p><strong>Website:</strong> <a href="https://mustan.dev" target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">mustan.dev</a></p>
          </div>
        </section>
      </div>
    </main>
  </div>
);

export default PrivacyPolicy;
